import React from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import SubtitleFilters from 'src/components/Charts/SubtitleFilters';
import { BeaconSubtitleContainer } from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconSubtitleContainer';
import { calculatePercentChange } from 'src/utils/app';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { useTaxonomySubtitleText } from 'src/components/BeaconV2Components/common/BeaconProDynamicSubtitle/hooks';
import { useMainTimePeriodShortDisplayName } from 'src/utils/Hooks/typedHooks';
import { useComparisonTimePeriodShortDisplayName } from 'src/utils/Hooks/typedHooks';
import { useEntityPhrasing } from 'src/components/BeaconV2Components/common/BeaconProDynamicSubtitle/hooks';
import { useBrandEntity, useCompanyName, useMainEntityType } from 'src/utils/Hooks/reduxSelectors';
import SplineChartLoading from 'src/components/BeaconV2Components/SplineChartLoading/SplineChartLoading';

const AtlasV2PaidTrafficV2ShareOfTrafficSplineChart = () => {
  const taxonomyText = useTaxonomySubtitleText();
  const mainTimePeriodShortDisplayName = useMainTimePeriodShortDisplayName();
  const comparisonTimePeriodShortDisplayName = useComparisonTimePeriodShortDisplayName();
  const entityPhrase = useEntityPhrasing();
  const companyName = useCompanyName();
  const mainEntityType = useMainEntityType();
  const { isBrandEntity } = useBrandEntity();

  return (
    <AtlasV2DorisSplineChart
      queryKey="shareOfPaidTrafficSplineChart"
      title="Share of Paid Search Traffic"
      metricTypeDisplay={METRICTYPE.PERCENT}
      metricType="adClicks"
      showMarketShare
      beaconChartWithLegendOverride={(props, metric) => {
        const { formattedPercentChange, formattedPrimaryTotal, primaryTotal, secondaryTotal } = metric;

        const percentChange = calculatePercentChange(primaryTotal, secondaryTotal);
        const percentDirection = percentChange >= 0 ? 'higher' : 'lower';

        return {
          ...props,
          includeSummaryInfo: false,
          loadingComponent: <SplineChartLoading includeSubtitle />,
          subtitle: (
            <BeaconSubtitleContainer>
              <Text variant="body1" lineHeight="24px">
                {`${
                  isBrandEntity ? entityPhrase : companyName
                } earned ${formattedPrimaryTotal} share of paid search traffic `}
                {!['company', 'brand'].includes(mainEntityType) ? `in ${entityPhrase} ` : ''}
                {taxonomyText}
                {` during the ${mainTimePeriodShortDisplayName} period, which is ${formattedPercentChange} ${percentDirection} compared to the ${comparisonTimePeriodShortDisplayName}.`}
                <SubtitleFilters showFilterNumber={false} />
              </Text>
            </BeaconSubtitleContainer>
          )
        };
      }}
    />
  );
};
export default AtlasV2PaidTrafficV2ShareOfTrafficSplineChart;
